module.exports = __webpack_public_path__ + "static/media/Hero_Image_Desktop_3.d907a930.jpg";